// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_nats_msg.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_nats_msg.proto.
 */
export const file_plugnmeet_nats_msg: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message plugnmeet.NatsSubjects
 */
export type NatsSubjects = Message<"plugnmeet.NatsSubjects"> & {
  /**
   * @generated from field: string system_api_worker = 1;
   */
  systemApiWorker: string;

  /**
   * jetstream worker
   *
   * @generated from field: string system_js_worker = 2;
   */
  systemJsWorker: string;

  /**
   * core pub/sub worker
   *
   * @generated from field: string system_core_worker = 3;
   */
  systemCoreWorker: string;

  /**
   * @generated from field: string system_public = 4;
   */
  systemPublic: string;

  /**
   * @generated from field: string system_private = 5;
   */
  systemPrivate: string;

  /**
   * @generated from field: string chat = 6;
   */
  chat: string;

  /**
   * @generated from field: string whiteboard = 7;
   */
  whiteboard: string;

  /**
   * @generated from field: string data_channel = 8;
   */
  dataChannel: string;
};

/**
 * Describes the message plugnmeet.NatsSubjects.
 * Use `create(NatsSubjectsSchema)` to create a new message.
 */
export const NatsSubjectsSchema: GenMessage<NatsSubjects> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 0);

/**
 * @generated from message plugnmeet.PrivateDataDelivery
 */
export type PrivateDataDelivery = Message<"plugnmeet.PrivateDataDelivery"> & {
  /**
   * @generated from field: string to_user_id = 1;
   */
  toUserId: string;

  /**
   * @generated from field: bool echo_to_sender = 2;
   */
  echoToSender: boolean;

  /**
   * @generated from field: string type = 3;
   */
  type: string;
};

/**
 * Describes the message plugnmeet.PrivateDataDelivery.
 * Use `create(PrivateDataDeliverySchema)` to create a new message.
 */
export const PrivateDataDeliverySchema: GenMessage<PrivateDataDelivery> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 1);

/**
 * @generated from message plugnmeet.NatsMsgServerToClient
 */
export type NatsMsgServerToClient = Message<"plugnmeet.NatsMsgServerToClient"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: plugnmeet.NatsMsgServerToClientEvents event = 2;
   */
  event: NatsMsgServerToClientEvents;

  /**
   * @generated from field: string msg = 3;
   */
  msg: string;

  /**
   * @generated from field: bytes bin_msg = 4;
   */
  binMsg: Uint8Array;
};

/**
 * Describes the message plugnmeet.NatsMsgServerToClient.
 * Use `create(NatsMsgServerToClientSchema)` to create a new message.
 */
export const NatsMsgServerToClientSchema: GenMessage<NatsMsgServerToClient> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 2);

/**
 * @generated from message plugnmeet.NatsMsgClientToServer
 */
export type NatsMsgClientToServer = Message<"plugnmeet.NatsMsgClientToServer"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: plugnmeet.NatsMsgClientToServerEvents event = 2;
   */
  event: NatsMsgClientToServerEvents;

  /**
   * @generated from field: string msg = 3;
   */
  msg: string;

  /**
   * @generated from field: bytes bin_msg = 4;
   */
  binMsg: Uint8Array;
};

/**
 * Describes the message plugnmeet.NatsMsgClientToServer.
 * Use `create(NatsMsgClientToServerSchema)` to create a new message.
 */
export const NatsMsgClientToServerSchema: GenMessage<NatsMsgClientToServer> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 3);

/**
 * @generated from message plugnmeet.NatsKvRoomInfo
 */
export type NatsKvRoomInfo = Message<"plugnmeet.NatsKvRoomInfo"> & {
  /**
   * @generated from field: uint64 db_table_id = 1 [jstype = JS_STRING];
   */
  dbTableId: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string room_sid = 3;
   */
  roomSid: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: uint64 empty_timeout = 5 [jstype = JS_STRING];
   */
  emptyTimeout: string;

  /**
   * @generated from field: uint64 max_participants = 6 [jstype = JS_STRING];
   */
  maxParticipants: string;

  /**
   * @generated from field: string metadata = 7;
   */
  metadata: string;

  /**
   * @generated from field: uint64 created_at = 8 [jstype = JS_STRING];
   */
  createdAt: string;
};

/**
 * Describes the message plugnmeet.NatsKvRoomInfo.
 * Use `create(NatsKvRoomInfoSchema)` to create a new message.
 */
export const NatsKvRoomInfoSchema: GenMessage<NatsKvRoomInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 4);

/**
 * @generated from message plugnmeet.NatsKvUserInfo
 */
export type NatsKvUserInfo = Message<"plugnmeet.NatsKvUserInfo"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string user_sid = 2;
   */
  userSid: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string room_id = 4;
   */
  roomId: string;

  /**
   * @generated from field: bool is_admin = 5;
   */
  isAdmin: boolean;

  /**
   * @generated from field: bool is_presenter = 6;
   */
  isPresenter: boolean;

  /**
   * @generated from field: string metadata = 7;
   */
  metadata: string;

  /**
   * @generated from field: uint64 joined_at = 8 [jstype = JS_STRING];
   */
  joinedAt: string;

  /**
   * @generated from field: uint64 reconnected_at = 9 [jstype = JS_STRING];
   */
  reconnectedAt: string;

  /**
   * @generated from field: uint64 disconnected_at = 10 [jstype = JS_STRING];
   */
  disconnectedAt: string;

  /**
   * session client type; Default: WEB
   *
   * @generated from field: plugnmeet.ClientType client_type = 11;
   */
  clientType: ClientType;
};

/**
 * Describes the message plugnmeet.NatsKvUserInfo.
 * Use `create(NatsKvUserInfoSchema)` to create a new message.
 */
export const NatsKvUserInfoSchema: GenMessage<NatsKvUserInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 5);

/**
 * @generated from message plugnmeet.FallbackOnFlapping
 */
export type FallbackOnFlapping = Message<"plugnmeet.FallbackOnFlapping"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * max number of times connection can be poor
   *
   * @generated from field: int32 max_poor_conn_count = 2;
   */
  maxPoorConnCount: number;

  /**
   * duration in seconds to check for poor connections
   *
   * @generated from field: int32 check_duration_in_sec = 3;
   */
  checkDurationInSec: number;
};

/**
 * Describes the message plugnmeet.FallbackOnFlapping.
 * Use `create(FallbackOnFlappingSchema)` to create a new message.
 */
export const FallbackOnFlappingSchema: GenMessage<FallbackOnFlapping> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 6);

/**
 * @generated from message plugnmeet.TurnCredentials
 */
export type TurnCredentials = Message<"plugnmeet.TurnCredentials"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: repeated string uris = 3;
   */
  uris: string[];

  /**
   * @generated from field: bool force_turn = 4;
   */
  forceTurn: boolean;

  /**
   * @generated from field: bool fallback_turn = 5;
   */
  fallbackTurn: boolean;

  /**
   * The duration in Seconds to wait with a poor connection before triggering the fallback.
   *
   * @generated from field: int64 fallback_timer_duration = 6 [jstype = JS_STRING];
   */
  fallbackTimerDuration: string;

  /**
   * @generated from field: optional plugnmeet.FallbackOnFlapping fallback_on_flapping = 7;
   */
  fallbackOnFlapping?: FallbackOnFlapping | undefined;
};

/**
 * Describes the message plugnmeet.TurnCredentials.
 * Use `create(TurnCredentialsSchema)` to create a new message.
 */
export const TurnCredentialsSchema: GenMessage<TurnCredentials> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 7);

/**
 * @generated from message plugnmeet.MediaServerConnInfo
 */
export type MediaServerConnInfo = Message<"plugnmeet.MediaServerConnInfo"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * @generated from field: bool enabled_e2ee = 3;
   */
  enabledE2ee: boolean;

  /**
   * @generated from field: optional plugnmeet.TurnCredentials turn_credentials = 4;
   */
  turnCredentials?: TurnCredentials | undefined;

  /**
   * LiveKit JWT for the [userID]-native publish-only twin; only set when the session is HYBRID_WEB
   *
   * @generated from field: string native_token = 5;
   */
  nativeToken: string;
};

/**
 * Describes the message plugnmeet.MediaServerConnInfo.
 * Use `create(MediaServerConnInfoSchema)` to create a new message.
 */
export const MediaServerConnInfoSchema: GenMessage<MediaServerConnInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 8);

/**
 * @generated from message plugnmeet.NatsInitialData
 */
export type NatsInitialData = Message<"plugnmeet.NatsInitialData"> & {
  /**
   * @generated from field: plugnmeet.NatsKvRoomInfo room = 1;
   */
  room?: NatsKvRoomInfo | undefined;

  /**
   * @generated from field: plugnmeet.NatsKvUserInfo local_user = 2;
   */
  localUser?: NatsKvUserInfo | undefined;
};

/**
 * Describes the message plugnmeet.NatsInitialData.
 * Use `create(NatsInitialDataSchema)` to create a new message.
 */
export const NatsInitialDataSchema: GenMessage<NatsInitialData> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 9);

/**
 * @generated from message plugnmeet.NatsSystemNotification
 */
export type NatsSystemNotification = Message<"plugnmeet.NatsSystemNotification"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: plugnmeet.NatsSystemNotificationTypes type = 2;
   */
  type: NatsSystemNotificationTypes;

  /**
   * @generated from field: string msg = 3;
   */
  msg: string;

  /**
   * @generated from field: int64 sent_at = 4 [jstype = JS_STRING];
   */
  sentAt: string;

  /**
   * @generated from field: bool with_sound = 5;
   */
  withSound: boolean;
};

/**
 * Describes the message plugnmeet.NatsSystemNotification.
 * Use `create(NatsSystemNotificationSchema)` to create a new message.
 */
export const NatsSystemNotificationSchema: GenMessage<NatsSystemNotification> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 10);

/**
 * @generated from message plugnmeet.NatsUserMetadataUpdate
 */
export type NatsUserMetadataUpdate = Message<"plugnmeet.NatsUserMetadataUpdate"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string metadata = 2;
   */
  metadata: string;
};

/**
 * Describes the message plugnmeet.NatsUserMetadataUpdate.
 * Use `create(NatsUserMetadataUpdateSchema)` to create a new message.
 */
export const NatsUserMetadataUpdateSchema: GenMessage<NatsUserMetadataUpdate> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 11);

/**
 * @generated from message plugnmeet.ChatMessage
 */
export type ChatMessage = Message<"plugnmeet.ChatMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string from_name = 2;
   */
  fromName: string;

  /**
   * @generated from field: string from_user_id = 3;
   */
  fromUserId: string;

  /**
   * @generated from field: int64 sent_at = 4 [jstype = JS_STRING];
   */
  sentAt: string;

  /**
   * @generated from field: optional string to_user_id = 5;
   */
  toUserId?: string | undefined;

  /**
   * @generated from field: bool is_private = 6;
   */
  isPrivate: boolean;

  /**
   * @generated from field: string message = 7;
   */
  message: string;

  /**
   * @generated from field: bool from_admin = 8;
   */
  fromAdmin: boolean;

  /**
   * @generated from field: optional string source_lang = 9;
   */
  sourceLang?: string | undefined;

  /**
   * @generated from field: map<string, string> translations = 10;
   */
  translations: { [key: string]: string };
};

/**
 * Describes the message plugnmeet.ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> = /*@__PURE__*/
  messageDesc(file_plugnmeet_nats_msg, 12);

/**
 * @generated from enum plugnmeet.NatsMsgServerToClientEvents
 */
export enum NatsMsgServerToClientEvents {
  /**
   * initial data
   *
   * @generated from enum value: RES_INITIAL_DATA = 0;
   */
  RES_INITIAL_DATA = 0,

  /**
   * @generated from enum value: RES_JOINED_USERS_LIST = 1;
   */
  RES_JOINED_USERS_LIST = 1,

  /**
   * @generated from enum value: RES_MEDIA_SERVER_DATA = 2;
   */
  RES_MEDIA_SERVER_DATA = 2,

  /**
   * @generated from enum value: ROOM_METADATA_UPDATE = 3;
   */
  ROOM_METADATA_UPDATE = 3,

  /**
   * @generated from enum value: USER_METADATA_UPDATE = 4;
   */
  USER_METADATA_UPDATE = 4,

  /**
   * @generated from enum value: USER_JOINED = 5;
   */
  USER_JOINED = 5,

  /**
   * @generated from enum value: USER_DISCONNECTED = 6;
   */
  USER_DISCONNECTED = 6,

  /**
   * @generated from enum value: USER_OFFLINE = 7;
   */
  USER_OFFLINE = 7,

  /**
   * @generated from enum value: RESP_RENEW_PNM_TOKEN = 8;
   */
  RESP_RENEW_PNM_TOKEN = 8,

  /**
   * @generated from enum value: SYSTEM_NOTIFICATION = 9;
   */
  SYSTEM_NOTIFICATION = 9,

  /**
   * @generated from enum value: SESSION_ENDED = 10;
   */
  SESSION_ENDED = 10,

  /**
   * @generated from enum value: POLL_CLOSED = 11;
   */
  POLL_CLOSED = 11,

  /**
   * @generated from enum value: POLL_CREATED = 12;
   */
  POLL_CREATED = 12,

  /**
   * @generated from enum value: JOIN_BREAKOUT_ROOM = 13;
   */
  JOIN_BREAKOUT_ROOM = 13,

  /**
   * @generated from enum value: BREAKOUT_ROOM_ENDED = 14;
   */
  BREAKOUT_ROOM_ENDED = 14,

  /**
   * mostly system message display in chat
   *
   * @generated from enum value: SYSTEM_CHAT_MSG = 15;
   */
  SYSTEM_CHAT_MSG = 15,

  /**
   * @generated from enum value: TRANSCRIPTION_OUTPUT_TEXT = 16;
   */
  TRANSCRIPTION_OUTPUT_TEXT = 16,

  /**
   * @generated from enum value: RESP_INSIGHTS_AI_TEXT_CHAT = 17;
   */
  RESP_INSIGHTS_AI_TEXT_CHAT = 17,

  /**
   * @generated from enum value: RESP_ONLINE_USERS_LIST = 18;
   */
  RESP_ONLINE_USERS_LIST = 18,

  /**
   * @generated from enum value: DELIVERY_PRIVATE_DATA = 19;
   */
  DELIVERY_PRIVATE_DATA = 19,

  /**
   * next ID: 21
   *
   * @generated from enum value: PONG = 20;
   */
  PONG = 20,
}

/**
 * Describes the enum plugnmeet.NatsMsgServerToClientEvents.
 */
export const NatsMsgServerToClientEventsSchema: GenEnum<NatsMsgServerToClientEvents> = /*@__PURE__*/
  enumDesc(file_plugnmeet_nats_msg, 0);

/**
 * @generated from enum plugnmeet.NatsMsgClientToServerEvents
 */
export enum NatsMsgClientToServerEvents {
  /**
   * @generated from enum value: REQ_INITIAL_DATA = 0;
   */
  REQ_INITIAL_DATA = 0,

  /**
   * @generated from enum value: REQ_MEDIA_SERVER_DATA = 1;
   */
  REQ_MEDIA_SERVER_DATA = 1,

  /**
   * @generated from enum value: REQ_JOINED_USERS_LIST = 2;
   */
  REQ_JOINED_USERS_LIST = 2,

  /**
   * @generated from enum value: REQ_RENEW_PNM_TOKEN = 3;
   */
  REQ_RENEW_PNM_TOKEN = 3,

  /**
   * @generated from enum value: PING = 4;
   */
  PING = 4,

  /**
   * @generated from enum value: REQ_RAISE_HAND = 5;
   */
  REQ_RAISE_HAND = 5,

  /**
   * @generated from enum value: REQ_LOWER_HAND = 6;
   */
  REQ_LOWER_HAND = 6,

  /**
   * @generated from enum value: REQ_LOWER_OTHER_USER_HAND = 7;
   */
  REQ_LOWER_OTHER_USER_HAND = 7,

  /**
   * @generated from enum value: PUSH_ANALYTICS_DATA = 8;
   */
  PUSH_ANALYTICS_DATA = 8,

  /**
   * @generated from enum value: REQ_ONLINE_USERS_LIST = 9;
   */
  REQ_ONLINE_USERS_LIST = 9,

  /**
   * next ID: 11
   *
   * @generated from enum value: REQ_PRIVATE_DATA_DELIVERY = 10;
   */
  REQ_PRIVATE_DATA_DELIVERY = 10,
}

/**
 * Describes the enum plugnmeet.NatsMsgClientToServerEvents.
 */
export const NatsMsgClientToServerEventsSchema: GenEnum<NatsMsgClientToServerEvents> = /*@__PURE__*/
  enumDesc(file_plugnmeet_nats_msg, 1);

/**
 * @generated from enum plugnmeet.ClientType
 */
export enum ClientType {
  /**
   * standard plugNmeet web client (default).
   *
   * @generated from enum value: WEB = 0;
   */
  WEB = 0,

  /**
   * web client running inside a native app's webview
   *
   * @generated from enum value: HYBRID_WEB = 1;
   */
  HYBRID_WEB = 1,
}

/**
 * Describes the enum plugnmeet.ClientType.
 */
export const ClientTypeSchema: GenEnum<ClientType> = /*@__PURE__*/
  enumDesc(file_plugnmeet_nats_msg, 2);

/**
 * @generated from enum plugnmeet.NatsSystemNotificationTypes
 */
export enum NatsSystemNotificationTypes {
  /**
   * @generated from enum value: NATS_SYSTEM_NOTIFICATION_INFO = 0;
   */
  NATS_SYSTEM_NOTIFICATION_INFO = 0,

  /**
   * @generated from enum value: NATS_SYSTEM_NOTIFICATION_WARNING = 1;
   */
  NATS_SYSTEM_NOTIFICATION_WARNING = 1,

  /**
   * @generated from enum value: NATS_SYSTEM_NOTIFICATION_ERROR = 2;
   */
  NATS_SYSTEM_NOTIFICATION_ERROR = 2,
}

/**
 * Describes the enum plugnmeet.NatsSystemNotificationTypes.
 */
export const NatsSystemNotificationTypesSchema: GenEnum<NatsSystemNotificationTypes> = /*@__PURE__*/
  enumDesc(file_plugnmeet_nats_msg, 3);

